export default {
  loading(state) {
    return state.detail.loading
  },
  news(state) {
    return state.news.list
  },
  newsAll(state) {
    return state.news.all
  },
}
